import React from "react";
import { withRouter } from "react-router-dom";
import "./index.css";
// import { ResizableBox } from 'react-resizable';
import { useEffect } from "react";

const ResizableDiv = ({
  widthpx,
  heightpx,
  children,
  onResize,
  minWidth = 256,
  minHeight = 256,
}) => {
  // const onResizeStop = (event, { size }) => {
  //     console.log('onResizeStop', size)
  //     onResize?.(size)
  // }
  const useRef = React.useRef(null);
  const useHandleRef = React.useRef(null);

  const useRefSize = React.useRef({ width: widthpx, height: heightpx });
  const useRefOffset = React.useRef({ offsetX: 0, offset: 0 });
  const useRefStart = React.useRef({ x: 0, y: 0 });

  useEffect(() => {
    const onMouseMove = (event) => {
      // console.log('onMouseMove', event)
      const deltaX = event.clientX - useRefStart.current.x;
      const deltaY = event.clientY - useRefStart.current.y;
      useRefSize.current.width = Math.max(
        minWidth,
        useRefOffset.current.offsetX + deltaX
      );
      useRefSize.current.height = Math.max(
        minHeight,
        useRefOffset.current.offsetY + deltaY
      );
      useRef.current.style.width = useRefSize.current.width + "px";
      useRef.current.style.height = useRefSize.current.height + "px";
    };
    const onMouseUp = (event) => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      onResize?.(useRefSize.current);
    };
    const onMouseDown = (event) => {
      // console.log('onMouseDown', event)
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
      useRefStart.current.x = event.clientX;
      useRefStart.current.y = event.clientY;
      useRefOffset.current.offsetX = useRefSize.current.width;
      useRefOffset.current.offsetY = useRefSize.current.height;
    };
    useHandleRef.current.addEventListener("mousedown", onMouseDown);
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      useHandleRef.current?.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={useRef}
      className="dash-react-block"
      style={{
        width: useRefSize.current.width,
        height: useRefSize.current.height,

      }}
    >
      {children}
      <div
        className="resize-handle"
        ref={useHandleRef}
        style={{
          position: "absolute",
          width: "20px",
          height: "20px",
          backgroundRepeat: "no-repeat",
          backgroundOrigin: "content-box",
          boxSizing: "border-box",
          backgroundImage:
            "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
          backgroundPosition: "bottom right",
          padding: "0 3px 3px 0",
          right: 0,
          bottom: 0,
          cursor: "se-resize",
        }}
      ></div>
    </div>
    // <ResizableBox
    //     width={widthpx}
    //     height={heightpx}
    //     // onResize={onResize}
    //     onResizeStop={onResizeStop}
    //     resizeHandles={['se']}
    //     style={{
    //         border: '1px solid #ccc',
    //         display: 'flex',
    //         alignItems: 'center',
    //         justifyContent: 'center',
    //         padding: '8px',
    //         marginBottom: '4px',
    //         marginRight: '4px',
    //     }}
    // >
    //     {children}
    // </ResizableBox>
  );
};

export default withRouter(ResizableDiv);
